/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Total_Events_HeaderInputs */



/**
* | output |
* | --- |
* | "Total Events" |
*
* @param {Explorer_Table_Total_Events_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_total_events_header = /** @type {((inputs?: Explorer_Table_Total_Events_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Total_Events_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Total des evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesamtereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi totali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Всего событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Total de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("总事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("合計イベント数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुल घटनाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Total de eventos")
	return /** @type {LocalizedString} */ ("Total Events")
});